import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

function MobileCurtains({ isActive, toggle }) {
  return (
    <div
      className={classnames(
        'mobile-curtains',
        isActive && 'is-active'
      )}
      onClick={toggle}
    />
  )
}

MobileCurtains.propTypes = {
  isActive: bool.isRequired,
  toggle: func.isRequired,
}

export default memo(MobileCurtains)
